var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-search"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search",
    clipPath: "url(#clip-search)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_awesome-search",
    "data-name": "Icon awesome-search",
    transform: "translate(2 0.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-search-2",
    "data-name": "Icon awesome-search",
    d: "M29.745,26.075,23.872,20.2a1.413,1.413,0,0,0-1-.412h-.96a12.246,12.246,0,1,0-2.12,2.12v.96a1.412,1.412,0,0,0,.412,1l5.872,5.872a1.408,1.408,0,0,0,2,0l1.667-1.667a1.42,1.42,0,0,0,.006-2ZM12.251,19.79a7.539,7.539,0,1,1,7.539-7.539A7.535,7.535,0,0,1,12.251,19.79Z",
    fill: "#f2f2f2"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.48ae07c6.svg";
export { ForwardRef as ReactComponent };